import { render, staticRenderFns } from "./BasePageTitle.vue?vue&type=template&id=5233c2d8&scoped=true&"
import script from "./BasePageTitle.vue?vue&type=script&lang=ts&"
export * from "./BasePageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./BasePageTitle.vue?vue&type=style&index=0&id=5233c2d8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233c2d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VIcon,VTooltip})
